var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-aside",
        { staticClass: "sidebar", attrs: { width: "180px" } },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-vertical-demo",
              attrs: { "default-active": _vm.pageActive }
            },
            [
              _c(
                "el-menu-item",
                {
                  attrs: { index: "0" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "index" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("工作台")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "1" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/texttoimage")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "text_to_image" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("文生图")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "2" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/workblank")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "image" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("上传底图")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "3" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/effectsave")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "edit" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("图生图")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "4" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/effectaiedit")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "ai_edit" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("AI改图")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "5" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/floorplantocolor")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "edit" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("平面图转彩平")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "6" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/colorto3d")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "image" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("平面转3D")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "7" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/texttovideo")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "text_to_video" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("文生视频")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "8" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/effectvideo")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "img_video" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("图生视频")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  attrs: { index: "9" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("/videostitching")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "img_video" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("拼接长视频")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.global.type == "manage"
                ? _c(
                    "el-menu-item",
                    {
                      attrs: { index: "10" },
                      on: {
                        click: function($event) {
                          return _vm.toPage("/effecthistory")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "image" }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v("效果生成历史")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.global.type == "manage"
                ? _c(
                    "el-menu-item",
                    {
                      attrs: { index: "11" },
                      on: {
                        click: function($event) {
                          return _vm.toPage("/material")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material" }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v("素材库")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.global.type == "manage"
                ? _c(
                    "el-menu-item",
                    {
                      attrs: { index: "12" },
                      on: {
                        click: function($event) {
                          return _vm.toPage("/materialperson")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material_person" }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v("个人素材库")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.global.type == "client"
                ? _c(
                    "el-menu-item",
                    {
                      attrs: { index: "13" },
                      on: {
                        click: function($event) {
                          return _vm.toPage("/customerdetail")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "image" }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v("效果生成历史")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45231cd1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45231cd1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBarComponent.vue
// module id = null
// module chunks = 